var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar fixed-top navbar-expand-lg navbar-light bg-light"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{name:'home'}}},[_c('img',{staticStyle:{"height":"3.8rem"},attrs:{"src":require("../assets/new-logo-small.png"),"alt":"AIED2020","title":""}})]),_vm._m(0),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('router-link',{attrs:{"to":{ name: 'home' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Home")])])]}}])}),_c('router-link',{attrs:{"to":"/dates"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Dates")])])]}}])}),_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#","id":"navbarDropdown","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Calls ")]),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"navbarDropdown"}},[_c('router-link',{attrs:{"to":{ name: 'general' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("General Call")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'industry' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Call for industry papers")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'tutorials' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Call for workshops")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'doctorial' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Doctoral Consortium")])]}}])})],1)]),_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#","id":"navbarDropdown","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Program ")]),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"navbarDropdown"}},[_c('router-link',{attrs:{"to":{ name: 'program' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Main conference program")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'accepted-full' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Accepted Full Papers")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'accepted-short' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Accepted Short Papers")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'program-workshops' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Accepted Workshops")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'accepted-industry' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Industry Track Papers")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'program-nominations' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Best Paper Nominations")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'proceedings' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Proceedings")])]}}])})],1)]),_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#","id":"navbarDropdown","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Organization ")]),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"navbarDropdown"}},[_c('router-link',{attrs:{"to":{ name: 'committee' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Organizing Committee")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'members' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"dropdown-item",attrs:{"href":href},on:{"click":navigate}},[_vm._v("PC members and reviewers")])]}}])})],1)]),_c('router-link',{attrs:{"to":{ name: 'keynotes' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Keynotes")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'speakers' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Speakers")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'sponsorship' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Sponsors")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'plataform' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Platform")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'report' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Report a Problem")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'reviewer' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item nav-especial', isExactActive && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v("Reviewer guidelines")])])]}}])})],1),_c('div',{staticClass:"navbar-text"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"tag":"button","to":{ name: 'registration' }}},[_vm._v(" Registration ")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]

export { render, staticRenderFns }